@for (position of positions; track position) {
  @let positionToasts = groupedToasts().get(position) ?? [];
  @if (positionToasts.length > 0) {
    <div
      class="toast-region"
      [class]="'toast-region--' + position"
      aria-label="Notifications"
      aria-live="polite"
    >
      @for (toast of positionToasts; track toast.id) {
        <toast-item [toast]="toast" (dismissed)="onDismissed($event)" />
      }
    </div>
  }
}
